import { Component, OnInit, Input } from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ConfigStateService, ApplicationConfiguration, SessionStateService, LocalizationService, LanguageInfo } from '@abp/ng.core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import snq from 'snq';



@Component({
	selector: 'abp-languages',
	template: `
	<!-- <div class="dropdown" ngbDropdown placement="bottom-right">
    <ng-container *ngIf="defaultLanguage$ | async as defaultLang">
        <div ngbDropdownToggle class="topbar-item" data-toggle="dropdown" data-offset="10px,0px">
            <div class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1">
                <span class="flag-icon flag-icon-squared flag-icon-{{ defaultLang.flagIcon }}"
                    [title]="defaultLang.displayName"></span>
                <span class="current-language-name ml-1">{{ defaultLang.displayName }}</span>
            </div>
        </div>
    </ng-container>
    <div *dropdownMenu class="dropdown-menu p-0 m-0 dropdown-menu-anim-up dropdown-menu-sm dropdown-menu-right">
        <ul class="navi navi-hover py-4">
            <ng-container *ngFor="let lang of (dropdownLanguages$ | async) || []">
                <li class="navi-item" [ngClass]="{ active: language.active }">
                    <a href="javascript:;" (click)="changeLang(lang.cultureName)"
                        [ngClass]="{ active: lang.active }" class="navi-link ">
                        <span class="symbol symbol-20 mr-3">
                            <span class="flag-icon flag-icon-{{ lang.flagIcon }} flag-icon-squared mr-2"></span>
                        </span>
                        <span class="navi-text">{{ lang?.displayName  }}</span>
                    </a>
                </li>
            </ng-container>
        </ul>
    </div> 
</div> -->
<div class="dropdown" ngbDropdown>
      <a
        *ngIf="defaultLanguage$ | async as defaultLang"
        class="btn topbar-item"
        role="button"
        id="dropdownMenuLink"
        ngbDropdownToggle
      >
        <span
          class="flag-icon flag-icon-squared flag-icon-{{ defaultLang.flagIcon }}"
          [title]="defaultLang.displayName"
        ></span>
        <span class="current-language-name ml-1">{{ defaultLang.displayName }}</span>
      </a>
      <div
        ngbDropdownMenu
        class="dropdown-menu dropdown-menu-right"
        *ngIf="(dropdownLanguages$ | async)?.length > 0"
      >
        <a
          *ngFor="let lang of (dropdownLanguages$ | async) || []"
          class="dropdown-item pointer"
          (click)="changeLang(lang.cultureName)"
        >
          <span class="flag-icon flag-icon-{{ lang.flagIcon }} flag-icon-squared mr-2"></span>
          {{ lang?.displayName }}</a
        >
      </div>
    </div>
	`, styles: [
		`
		.dropdown{
			height:100%
		}
		`
	]
})
export class LanguagesComponent implements OnInit {

	get smallScreen(): boolean {
		return window.innerWidth < 992;
	}

	languages$ = this.configState.getDeep$('localization.languages');

	get defaultLanguage$(): Observable<{ displayName: string; flagIcon: string }> {
		return this.languages$.pipe(
			map(languages => {
				const lang: Partial<LanguageInfo> = snq(
					() => languages.find(language => language.cultureName === this.selectedLangCulture),
					{} as Partial<LanguageInfo>,
				);
				return {
					displayName: lang.displayName || '',
					flagIcon: lang.flagIcon,
				};
			}),
		);
	}

	get dropdownLanguages$(): Observable<LanguageInfo[]> {
		return this.languages$.pipe(
			map(
				languages =>
					snq(() => languages.filter(lang => lang.cultureName !== this.selectedLangCulture)),
				[],
			),
		);
	}

	get selectedLangCulture(): string {
		return this.sessionState.getLanguage();
	}

	constructor(
		private configState: ConfigStateService, private sessionState: SessionStateService) {

	}

	ngOnInit() {
		// console.log('zh-Hans')
		// this.changeLang('zh-Hans')
	}

	changeLang(cultureName: string) {
		this.sessionState.setLanguage(cultureName);
	}
}
